export default __webpack_public_path__ + "static/media/image00005.0f40ab74.jpeg";